import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { provideIcons } from '@ng-icons/core';
import { ngIcons } from '@wheere-front/inside-shared-data-access';
import { KeycloakUserConnectService } from '@wheere-front/shared-auth';
import { PrimeNG } from 'primeng/config';
import { NetworkPollingService } from '@wheere-front/shared-util';
import { WhToastComponent } from '@wheere-front/shared-ui';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, WhToastComponent],
  // Le toast unique de l'app : tout `MessageService.add(...)` s'affiche ici, quelle que soit sa key.
  template: ` <router-outlet />
    <wh-toast />`,
  providers: [provideIcons(ngIcons)],
})
export class AppComponent {
  #keycloakUserConnectService = inject(KeycloakUserConnectService);

  constructor(
    private primeNG: PrimeNG,
    private networkPolling: NetworkPollingService
  ) {
    this.#keycloakUserConnectService.init();
    this.primeNG.ripple.set(true);
  }
}
